module.exports = __webpack_public_path__ + "img/corporate_history.19c7b192.png";